import { Store } from 'redux';
import { RouterState, RedirectFunction } from 'react-router';

import { GlobalState } from 'ha/types/store';
import { getInfo } from 'ha/modules/Hermes';
import removeTrailingSlash from 'ha/utils/urls/removeTrailingSlash';

export default (store: Store<GlobalState>) => (
  nextState: RouterState,
  replace: RedirectFunction,
) => {
  const decodedPathname = decodeURIComponent(nextState.location.pathname);

  if (
    // All languages except en should be redirected to closing slash
    ['/de', '/nl', '/es', '/it', '/fr', '/pt', '/zh'].includes(decodedPathname)
  ) {
    replace({
      ...nextState.location,
      pathname: `${decodedPathname}/`,
    });

    return;
  }

  if (decodedPathname.length > 1 && decodedPathname.endsWith('/')) {
    replace({
      ...nextState.location,
      pathname: removeTrailingSlash(decodedPathname),
    });

    return;
  }

  const info = getInfo(store.getState());

  if (info) {
    let newPathname = decodedPathname;

    if (
      info.path.toLowerCase() === newPathname.toLowerCase() &&
      info.path !== newPathname
    ) {
      newPathname = info.path;
    }

    if (newPathname !== decodedPathname) {
      replace({
        ...nextState.location,
        pathname: newPathname,
      });
    }

    if (info.redirect) {
      replace({
        ...nextState.location,
        pathname: info.redirect,
      });
    }
  }
};
